import type { LiteralUnion, Paths, UnionToTuple } from "type-fest";
import { z } from "zod";

import { zOutSchema2 } from "./common";

import type { ReviewServicePorts } from "~/entities/review/model";
import { Request, Response } from "~/shared/api";

const zRes200 = Response.Schema.zSuccessful(200, Request.Pagination.Page.zSchema(zOutSchema2));
type Res200 = z.infer<typeof zRes200>;

const zRes401 = Response.Schema.zNoBody(401);

const zRes = Response.Schema.zAggregated([zRes200, zRes401]);
type Res = z.infer<typeof zRes>;

const zFieldsToSortBy = z.enum(
  Object.values(zRes200.shape.body.shape.data.shape.items.element.keyof().Enum) as UnionToTuple<
    Paths<Res200["body"]["data"]["items"][number]>
  >,
);
const FieldsToSortBy = zFieldsToSortBy.Enum;
type FieldsToSortBy = z.infer<typeof zFieldsToSortBy>;

const MAP_OF_FIELDS_TO_SORT_BY: Record<
  ReviewServicePorts.ProviderIos.GetPaginatedForAdmin.FieldsToSortBy,
  LiteralUnion<FieldsToSortBy, string>
> = {
  id: "id",
  rating: "rating",
  pros: "pros",
  cons: "cons",
  text: "reviewContent",
  isApproved: "isApproved",
  createdAt: "createdAt",
  orderNumber: "order.orderNumber",
  "customer.email": "contactEmail",
  "customer.phone": "contactPhone",
  "customer.firstName": "firstName",
  "customer.lastName": "lastName",
};

export { FieldsToSortBy, MAP_OF_FIELDS_TO_SORT_BY, zFieldsToSortBy, zRes };
export type { Res };
